export default function ShowHideInteraction(root: HTMLElement) {
  if (!root)
    return () => {
      console.log("root isn't init'd yet")
    }

  const showHideTriggers = root.querySelectorAll(
    '.showhide-trigger',
  ) as NodeListOf<HTMLElement>
  const showHides = document.querySelectorAll(
    '.showhide',
  ) as NodeListOf<HTMLElement>

  const triggerHandler = (e: Event) => {
    const trigger = e.currentTarget as HTMLElement
    const clickedOrdinary = trigger.dataset.ordinary || 0

    if (trigger.classList.contains('active')) {
      document.querySelectorAll('.showhide').forEach((hiding_element) => {
        ;(hiding_element as HTMLElement).style.display = 'none'
      })
      trigger.classList.remove('active')
      return
    }

    showHideTriggers.forEach((showhide_trigger) => {
      const showhide_trigger_element = showhide_trigger as HTMLElement
      const showhide_trigger_ordinary =
        showhide_trigger_element.dataset.ordinary || 0
      if (clickedOrdinary !== showhide_trigger_ordinary) {
        return false //deactivate only if we're dealing on the same ordinary level
      }
      showhide_trigger.classList.remove('active')
    })

    trigger.classList.add('active')
    const triggeredElement = trigger.dataset.triggerFor
    document.querySelectorAll('.showhide').forEach((hiding_element) => {
      const hidingElement = hiding_element as HTMLElement
      const elementOrdinary = hidingElement.dataset.ordinary || 0
      if (clickedOrdinary !== elementOrdinary) {
        return false //hide only if we're dealing on the same ordinary level
      }
      hidingElement.style.display = 'none'
    })
    document
      .querySelectorAll(`.showhide[trigger=${triggeredElement}]`)
      .forEach((el) => {
        ;(el as HTMLElement).style.display = 'block'
      })
  }

  // Attach listeners
  showHides.forEach((el) => (el.style.display = 'none'))
  showHideTriggers.forEach((el) => el.addEventListener('click', triggerHandler))

  // Cleanup
  return () => {
    showHideTriggers.forEach((el) =>
      el.removeEventListener('click', triggerHandler),
    )
  }
}
